// extracted by mini-css-extract-plugin
export var carrierIcon = "_y8-0";
export var carrierLogo = "_y8-1";
export var detailsSection = "_y8-2";